import styles from '@/components/PageLoading/PageLoading.module.less';
import Spin from 'antd/es/spin';
import type { FC } from 'react';

const PageLoading: FC = () => {
  return (
    <div className={styles.page}>
      <Spin size="large" />
    </div>
  );
};

export default PageLoading;
